module.exports = __webpack_public_path__ + "static/media/jpg.9c9ea232.svg";